<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h1>📦 Inventory System</h1>
        <p>Please sign in to continue</p>
      </div>
      
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">Username</label>
          <input
            id="username"
            v-model="username"
            type="text"
            placeholder="Enter your username"
            required
            :disabled="loading"
          />
        </div>
        
        <div class="form-group">
          <label for="password">Password</label>
          <input
            id="password"
            v-model="password"
            type="password"
            placeholder="Enter your password"
            required
            :disabled="loading"
          />
        </div>
        
        <div v-if="error" class="error">
          {{ error }}
        </div>
        
        <button 
          type="submit" 
          class="btn btn-primary login-btn"
          :disabled="loading"
        >
          {{ loading ? 'Signing in...' : 'Sign In' }}
        </button>
      </form>
      
      <div class="login-help">
        <p><strong>Demo Accounts:</strong></p>
        <p>Owner: <code>owner</code> / <code>password</code></p>
        <p>Cashier: <code>cashier</code> / <code>password</code></p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()
    
    const username = ref('')
    const password = ref('')
    const error = ref('')
    const loading = ref(false)

    const handleLogin = async () => {
      if (!username.value || !password.value) {
        error.value = 'Please enter both username and password'
        return
      }

      loading.value = true
      error.value = ''

      const result = await authStore.login(username.value, password.value)

      if (result.success) {
        // Redirect based on user role
        if (authStore.user?.role === 'OWNER') {
          router.push('/dashboard')
        } else {
          router.push('/scan')
        }
      } else {
        error.value = result.error
      }

      loading.value = false
    }

    return {
      username,
      password,
      error,
      loading: ref(loading),
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 2rem;
}

.login-card {
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-header h1 {
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 2rem;
}

.login-header p {
  color: #7f8c8d;
  font-size: 1rem;
}

.login-form {
  margin-bottom: 2rem;
}

.login-btn {
  width: 100%;
  font-size: 1.1rem;
  padding: 1rem;
}

.login-help {
  text-align: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #6c757d;
}

.login-help p {
  margin: 0.25rem 0;
}

.login-help code {
  background-color: #e9ecef;
  padding: 0.125rem 0.25rem;
  border-radius: 3px;
  font-family: monospace;
}
</style> 